import React from 'react';

interface IProps {
    text: string;
}

const DividerNotification = ({ text }: IProps) => (
    <div className="flex items-center gap-x-2.5  !mt-4 ai-notification">
        <div className="flex-1 h-px bg-utilityGray200" />
        <p className="text-gray500 text-[10px] leading-[14px] font-medium whitespace-nowrap">{text}</p>
        <div className="flex-1 h-px bg-utilityGray200" />
    </div>
);

export default DividerNotification;
